import { render, staticRenderFns } from "./listProductServiceModal.vue?vue&type=template&id=08f41b80&"
import script from "./listProductServiceModal.vue?vue&type=script&lang=ts&"
export * from "./listProductServiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports